var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEbtCardSolid = function SvgEbtCardSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6a3 3 0 0 0-3 3v8a2.992 2.992 0 0 0 1.836 2.766V14C4.836 12 6 11 8 11h13V8a3 3 0 0 0-3-3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5h12a3 3 0 0 1 3 3v3H8c-2 0-3.164.908-3.164 3v4.766A3.002 3.002 0 0 1 3 16V8a3 3 0 0 1 3-3ZM5 7.25a.75.75 0 0 0 0 1.5h14a.75.75 0 0 0 0-1.5H5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 14H8v2.667m2.667 2.666H8v-2.666m2.222 0H8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.926 16.667c.654 0 1.185-.597 1.185-1.334 0-.736-.53-1.333-1.185-1.333h-1.482v2.667m1.482 0h-1.482m1.482 0c.654 0 1.185.597 1.185 1.333s-.53 1.333-1.185 1.333h-1.482v-2.666",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.222 14H20m1.778 0H20m0 0v5.333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgEbtCardSolid;